/**
 * Why we (currently) need this file:
 *
 * If this was defined in a client component, there would be a dependency from a server component to a client component which
 * seems not to be allowed if searchParams are used!
 */

export enum ScreensetScreens {
  LOGIN_SCREEN = 'gigya-login-screen',
  REGISTER_SCREEN = 'gigya-register-screen',
  AMNESIA_SCREEN = 'gigya-forgot-password-screen',
  RESET_PASSWORD_SCREEN = 'gigya-reset-password-screen',
}
